// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"436":"d011e587","818":"d011e587","953":"d011e587","2096":"78384348","2961":"6b05651b","3978":"67800340","4082":"702078e9","4456":"d011e587","4749":"2b2772df","4759":"d011e587","5081":"e9fb51c5","8471":"d011e587","9714":"f8c70d64"}[chunkId] + ".chunk.css";
};